import React from "react";
import { printImg } from "../../master/Print";
import EnquiryForm1 from "../components/EnquiryForm1";
import EnquiryForm2 from "../components/EnquiryForm2";
import useAppConfig from "../../config/useAppConfig";
import usePrivateLink from "../../config/usePrivateLink";

export default function EnquiryForm({ data }) {
  const config = useAppConfig("Enquiry", "enquiry_form");
  const hasAccess = usePrivateLink();

  return (
    <div className="card">
      <div className="card-body">
        <div className="row">
          <div className="col-12 text-end mb-1">
            {hasAccess("/enquiry/form/print") && (
              <button
                className="btn btn-info"
                onClick={() => printImg("PrintDiv")}
              >
                <i className="ri-printer-line"></i>
              </button>
            )}

          </div>
          <div className="col-12">
            {config?.value === "enquiry_form_1" ? (
              <EnquiryForm1 data={data} />
            ) : (
              config?.value === "enquiry_form_2" && <EnquiryForm2 data={data} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
